var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverSubsInact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6402 12.2389C21.4796 12.131 21.2754 12.1033 21.0935 12.167C21.0335 12.1876 19.9499 12.5678 19.1862 13.5157C18.5625 12.4358 17.8025 11.5468 16.2927 10.7375C16.1115 10.6396 15.8897 10.6396 15.7084 10.7375C14.2023 11.5421 13.458 12.4081 12.8192 13.514C12.0549 12.5614 10.9628 12.1864 10.9022 12.1664C10.7203 12.1057 10.5179 12.1322 10.3591 12.2401C9.39301 12.8938 9.33301 16.5287 9.33301 16.5646C9.33301 19.66 10.0585 20.7494 10.1409 20.8632C10.2118 20.9611 10.3118 21.0353 10.4276 21.0766C10.5325 21.1143 13.038 21.9974 16 21.9974C18.9619 21.9974 21.4669 21.1143 21.5717 21.0766C21.6899 21.0347 21.7912 20.9575 21.8627 20.8573C21.9451 20.7406 22.6663 19.6318 22.6663 16.5646C22.6663 16.5281 22.6057 12.8932 21.6402 12.2401V12.2389Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverSubsInact);
export default __webpack_public_path__ + "static/media/driverSubsInact.2b4d216f04b09b897aa9e1c08633dea8.svg";
export { ForwardRef as ReactComponent };